import { useMemo } from 'react';
import { FRIENDS_REGISTRY_ROUTES } from './FriendsRegistry.constants';

type FriendsRoutes = typeof FRIENDS_REGISTRY_ROUTES;
type FriendsRouteeKey = keyof FriendsRoutes;

type FriendsRoutePaths = {
  [Key in FriendsRouteeKey]: {
    path: FriendsRoutes[Key];
  };
};

export const useFriendsRegistryRoutePaths = () => {
  const friendsRegistryRoutes = useMemo<FriendsRoutePaths>(() => {
    return Object.keys(FRIENDS_REGISTRY_ROUTES).reduce((acc, key) => {
      const path = FRIENDS_REGISTRY_ROUTES[key as FriendsRouteeKey];
      acc[key as FriendsRouteeKey] = {
        // Type 'string' is not assignable to type 'never'.
        // @ts-ignore
        path,
      };
      return acc;
    }, {} as UnsealedReadonly<FriendsRoutePaths>);
  }, []);

  return { friendsRegistryRoutes };
};
